import { render } from "./SolarProductsTable.vue?vue&type=template&id=167acf47"
import script from "./SolarProductsTable.vue?vue&type=script&lang=js"
export * from "./SolarProductsTable.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__